import { render } from "./TextGrid.vue?vue&type=template&id=6c625523&scoped=true"
import script from "./TextGrid.vue?vue&type=script&lang=js"
export * from "./TextGrid.vue?vue&type=script&lang=js"

import "./TextGrid.vue?vue&type=style&index=0&id=6c625523&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c625523"]])

export default __exports__